/**
 * Deduces size for svg
 * @param {Object} sizeObj
 * @param {String} size
 * @returns {String}
 */
export const svgSize = (sizeObj, size) => {
  switch (size) {
    case "xs":
      return sizeObj.xs
    case "s":
      return sizeObj.sm
    case "m":
      return sizeObj.md
    case "l":
      return sizeObj.lg
    default:
      return sizeObj.md
  }
}

/**
 * Determines if a link opens in a new tab (or window)
 *
 * Reference: https://developer.mozilla.org/en-US/docs/Web/HTML/Link_types/noopener
 *
 * @param {string} target target attribute
 * @returns {boolean}
 */
export const opensInNewTab = (target) =>
  target && !(target === "_self" || target === "_top" || target === "_parent")

/**
 * Returns `rel` attribute if link opens in a new tab
 * to avoid [security and privacy risks](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#security_and_privacy)
 *
 * @param {string} target target attribute
 * @returns {Object}
 */
export const getRelAttributes = (target) =>
  opensInNewTab(target) ? { rel: "noreferrer" } : {}

/**
 * Gives supported size, defaults to 'm'
 * @param {string} size
 * @returns {string}
 */
export const resolveSizeProp = (size) => {
  const supportedSizes = ["xs", "s", "m", "l"]
  return supportedSizes.includes(size) ? size : "m"
}
